// Direct port of ~/Desktop/calyx-erp/src/data/productOptions.ts. Prices in cents
// to mirror the backend `/deal-catalog/products` cents-aligned response.

import type { ProductGroup, ProductOption } from '../../types/catalog'

export const PRODUCT_OPTIONS: ProductGroup[] = [
  {
    group: 'AI Eye Camera Platform',
    items: [
      { value: 'ai_eye_hw_lease', name: 'AI Eye Hardware (Lease)', priceCents: 110000, unit: '/yr', sub: 'hw', priceLabel: '$1,100/unit/yr', priceSuffix: '/unit/yr' },
      { value: 'ai_eye_sw_lite', name: 'AI Eye Software — Lite', priceCents: 137500, unit: '/yr', sub: 'sw', priceLabel: '$1,375/house/yr', priceSuffix: '/house/yr' },
      { value: 'ai_eye_sw_pro', name: 'AI Eye Software — Pro (AI Harvest)', priceCents: 220000, unit: '/yr', sub: 'sw', priceLabel: '$2,200/house/yr', priceSuffix: '/house/yr' },
      { value: 'data_monthly_starlink', name: 'Annual Data — Starlink', priceCents: 54000, unit: '/yr', sub: 'otp', priceLabel: '$540/yr', priceSuffix: '/yr' },
    ],
  },
  {
    group: 'Compact NH3 Sensor',
    items: [
      { value: 'nh3_wired', name: 'Compact NH3 Sensor (Wired)', priceCents: 69000, unit: '/yr', sub: 'otp', priceLabel: '$690/yr', priceSuffix: '/yr' },
    ],
  },
  {
    group: 'Y-Series Wireless',
    items: [
      { value: 'ywl_4in1_nh3co2', name: 'Y-Series Wireless — 4-in-1 (NH3/CO2/Temp/Humidity)', priceCents: 118500, unit: '/yr', sub: 'otp', priceLabel: '$1,185/yr', priceSuffix: '/yr' },
      { value: 'ywl_4in1_nh3wind', name: 'Y-Series Wireless — 4-in-1 (NH3/Wind/Temp/Humidity)', priceCents: 118600, unit: '/yr', sub: 'otp', priceLabel: '$1,186/yr', priceSuffix: '/yr' },
      { value: 'ywl_nh3co2wind', name: 'Y-Series Wireless — NH3 + CO2 + Wind', priceCents: 127400, unit: '/yr', sub: 'otp', priceLabel: '$1,274/yr', priceSuffix: '/yr' },
      { value: 'ywl_nh3co2', name: 'Y-Series Wireless — NH3 + CO2', priceCents: 101500, unit: '/yr', sub: 'otp', priceLabel: '$1,015/yr', priceSuffix: '/yr' },
      { value: 'ywl_nh3wind', name: 'Y-Series Wireless — NH3 + Wind', priceCents: 101500, unit: '/yr', sub: 'otp', priceLabel: '$1,015/yr', priceSuffix: '/yr' },
      { value: 'ywl_nh3temp', name: 'Y-Series Wireless — NH3 + Temp/Humidity', priceCents: 92600, unit: '/yr', sub: 'otp', priceLabel: '$926/yr', priceSuffix: '/yr' },
      { value: 'ywl_nh3', name: 'Y-Series Wireless — NH3 only', priceCents: 75600, unit: '/yr', sub: 'otp', priceLabel: '$756/yr', priceSuffix: '/yr' },
    ],
  },
  {
    group: 'Y-Series Hybrid',
    items: [
      { value: 'yhy_4in1_nh3co2', name: 'Y-Series Hybrid — 4-in-1 (NH3/CO2/Temp/Humidity)', priceCents: 143800, unit: '/yr', sub: 'otp', priceLabel: '$1,438/yr', priceSuffix: '/yr' },
      { value: 'yhy_4in1_nh3wind', name: 'Y-Series Hybrid — 4-in-1 (NH3/Wind/Temp/Humidity)', priceCents: 143900, unit: '/yr', sub: 'otp', priceLabel: '$1,439/yr', priceSuffix: '/yr' },
      { value: 'yhy_nh3co2wind', name: 'Y-Series Hybrid — NH3 + CO2 + Wind', priceCents: 152700, unit: '/yr', sub: 'otp', priceLabel: '$1,527/yr', priceSuffix: '/yr' },
      { value: 'yhy_nh3co2', name: 'Y-Series Hybrid — NH3 + CO2', priceCents: 126700, unit: '/yr', sub: 'otp', priceLabel: '$1,267/yr', priceSuffix: '/yr' },
      { value: 'yhy_nh3wind', name: 'Y-Series Hybrid — NH3 + Wind', priceCents: 126800, unit: '/yr', sub: 'otp', priceLabel: '$1,268/yr', priceSuffix: '/yr' },
      { value: 'yhy_nh3temp', name: 'Y-Series Hybrid — NH3 + Temp/Humidity', priceCents: 118000, unit: '/yr', sub: 'otp', priceLabel: '$1,180/yr', priceSuffix: '/yr' },
      { value: 'yhy_nh3', name: 'Y-Series Hybrid — NH3 only', priceCents: 100900, unit: '/yr', sub: 'otp', priceLabel: '$1,009/yr', priceSuffix: '/yr' },
    ],
  },
  {
    group: 'Y-Series Wired',
    items: [
      { value: 'yw_4in1_nh3co2', name: 'Y-Series Wired — 4-in-1 (NH3/CO2/Temp/Humidity)', priceCents: 130900, unit: '/yr', sub: 'otp', priceLabel: '$1,309/yr', priceSuffix: '/yr' },
      { value: 'yw_4in1_nh3wind', name: 'Y-Series Wired — 4-in-1 (NH3/Wind/Temp/Humidity)', priceCents: 130900, unit: '/yr', sub: 'otp', priceLabel: '$1,309/yr', priceSuffix: '/yr' },
      { value: 'yw_nh3co2wind', name: 'Y-Series Wired — NH3 + CO2 + Wind', priceCents: 139800, unit: '/yr', sub: 'otp', priceLabel: '$1,398/yr', priceSuffix: '/yr' },
      { value: 'yw_nh3co2', name: 'Y-Series Wired — NH3 + CO2', priceCents: 113900, unit: '/yr', sub: 'otp', priceLabel: '$1,139/yr', priceSuffix: '/yr' },
      { value: 'yw_nh3wind', name: 'Y-Series Wired — NH3 + Wind', priceCents: 113900, unit: '/yr', sub: 'otp', priceLabel: '$1,139/yr', priceSuffix: '/yr' },
      { value: 'yw_nh3temp', name: 'Y-Series Wired — NH3 + Temp/Humidity', priceCents: 90900, unit: '/yr', sub: 'otp', priceLabel: '$909/yr', priceSuffix: '/yr' },
      { value: 'yw_nh3', name: 'Y-Series Wired — NH3 only', priceCents: 78000, unit: '/yr', sub: 'otp', priceLabel: '$780/yr', priceSuffix: '/yr' },
    ],
  },
  {
    group: 'Accessories',
    items: [
      { value: 'water_meter', name: 'Ultrasonic Water Meter', priceCents: 40000, unit: '/yr', sub: 'otp', priceLabel: '$400/yr', priceSuffix: '/yr' },
      { value: 'y_gateway', name: 'Y-Series Gateway', priceCents: 40000, unit: '', sub: 'otp', priceLabel: '$400', priceSuffix: '' },
      { value: 'gateway_ethernet', name: 'Gateway (Ethernet)', priceCents: 22000, unit: '', sub: 'otp', priceLabel: '$220', priceSuffix: '' },
      { value: 'gateway_ethernet_4g', name: 'Gateway (Ethernet + 4G)', priceCents: 30000, unit: '', sub: 'otp', priceLabel: '$300', priceSuffix: '' },
      { value: 'wireless_bridge', name: 'Wireless Bridge', priceCents: 8000, unit: '', sub: 'otp', priceLabel: '$80', priceSuffix: '' },
      { value: 'data_modem_verizon', name: 'Cellular Modem — Verizon', priceCents: 7500, unit: '', sub: 'otp', priceLabel: '$75 one-time', priceSuffix: ' one-time' },
      { value: 'data_modem_starlink', name: 'Cellular Modem — Starlink', priceCents: 70000, unit: '', sub: 'otp', priceLabel: '$700 one-time', priceSuffix: ' one-time' },
    ],
  },
  {
    group: 'Data Plan',
    items: [
      { value: 'data_monthly_verizon', name: 'Monthly Data — Verizon', priceCents: 7500, unit: '/mo', sub: 'otp', priceLabel: '$75/mo', priceSuffix: '/mo' },
      { value: 'data_y_annual', name: 'Y-Series Annual Data Plan', priceCents: 5000, unit: '/yr', sub: 'otp', priceLabel: '$50/sensor/yr', priceSuffix: '/sensor/yr' },
    ],
  },
  {
    group: 'Installation & Shipping',
    items: [
      { value: 'install_3rdparty', name: 'Installation — 3rd party equipment support', priceCents: 50000, unit: '', sub: 'otp', priceLabel: '$500/unit', priceSuffix: '/unit' },
      { value: 'ship_intl', name: 'International Shipping (DHL / FedEx)', priceCents: 110000, unit: '', sub: 'otp', priceLabel: '$1,100+', priceSuffix: '' },
    ],
  },
]

export function findProductItem(value: string): ProductOption | null {
  for (const group of PRODUCT_OPTIONS) {
    const hit = group.items.find((option) => option.value === value)
    if (hit) return hit
  }
  return null
}

